import { bootstrapPortal } from "@/shared/app/bootstrapPortal";
import GuestApp from "./App.guest";

bootstrapPortal("guest", <GuestApp />);
